import { tenantModules } from '../config/modules';

/** Modules that can participate in cross-module relationships */
const EXCLUDED_MODULE_KEYS = new Set(['dashboard', 'reports', 'settings', 'roles', 'crm']);

export const RELATIONSHIP_MODULE_OPTIONS = tenantModules
  .filter((m) => !EXCLUDED_MODULE_KEYS.has(m.key))
  .map((m) => ({ value: m.key, label: m.title }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const RELATION_TYPES = [
  { value: 'lookup', label: 'Lookup / Reference' },
  { value: 'belongs_to', label: 'Belongs To (Many-to-One)' },
  { value: 'has_one', label: 'Has One (One-to-One)' },
  { value: 'has_many', label: 'Has Many (One-to-Many)' },
  { value: 'many_to_many', label: 'Many to Many' },
  { value: 'parent_child', label: 'Parent / Child' },
] as const;

export type RelationTypeValue = typeof RELATION_TYPES[number]['value'];

export function getRelationTypeLabel(value?: string): string {
  const match = RELATION_TYPES.find((t) => t.value === value);
  return match?.label || value || 'Lookup / Reference';
}

export function getModuleLabel(key?: string): string {
  const match = RELATIONSHIP_MODULE_OPTIONS.find((m) => m.value === key);
  return match?.label || key || '—';
}

export function buildRelationshipLabel(
  sourceModule: string,
  targetModule: string,
  relationType: string
): string {
  const source = getModuleLabel(sourceModule);
  const target = getModuleLabel(targetModule);
  const type = getRelationTypeLabel(relationType);
  return `${source} → ${target} (${type})`;
}
